import PropTypes from 'prop-types';

export default PropTypes.shape({
  params: PropTypes.shape({
    deviceId: PropTypes.string.isRequired
  }),
  url: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
});
